import React from 'react';
import PropTypes from 'prop-types';
import uuidV4 from 'uuid/v4';

export function StarIcon({fillPercentage, className}) {
  const offset = `${fillPercentage}%`;
  const gradientId = `StarGradient${uuidV4()}`;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
    >
      <defs>
        <linearGradient id={gradientId}>
          <stop className="stop1" offset="0%" />
          <stop className="stop2" offset={offset} />
          <stop className="stop3" offset={offset} />
          <stop className="stop4" offset="100%" />
        </linearGradient>
      </defs>
      <path
        d="M4.2 17a.8.8 0 0 1-.47-.152.8.8 0 0 1-.322-.762l.743-5.203-2.917-2.917a.8.8 0 0 1-.196-.81.798.798 0 0 1 .63-.545l4.398-.733 2.218-4.435A.808.808 0 0 1 9.004 1a.8.8 0 0 1 .715.45l2.123 4.362 4.498.801a.8.8 0 0 1 .623.547.798.798 0 0 1-.198.806l-2.917 2.917.744 5.203a.8.8 0 0 1-.327.764.799.799 0 0 1-.827.063l-4.382-2.219-4.502 2.223A.792.792 0 0 1 4.2 17z"
        stroke="currentFill"
        fill={`url(#${gradientId})`}
        fillRule="nonzero"
      />
    </svg>
  );
}

StarIcon.propTypes = {
  fillPercentage: PropTypes.number.isRequired,
  className: PropTypes.string.isRequired,
};
